import { Injectable } from '@angular/core'
const MOBILE_WIDTH = 480

@Injectable()
export class ApplicationStateService {
  public getIsMobileResolution(): boolean {
    return window.innerWidth <= MOBILE_WIDTH
  }
}
